const LAND_HOME_KEY = 'xph_land_on_home';

function writeHome(userId) {
  localStorage.setItem('xph_last_page', 'home');
  if (userId) localStorage.setItem(`xph_last_page_${userId}`, 'home');
  // A previous account in this browser must not decide the new user's
  // first Analytics or Automation module.
  localStorage.removeItem('xph_analytics_active_tab');
  localStorage.removeItem('xph_agentic_ai_active_tab');
}

/** Call when a brand-new account is created, before the dashboard mounts. */
export function markFirstSignupHome(userId) {
  try {
    writeHome(userId);
    localStorage.setItem(LAND_HOME_KEY, '1');
  } catch { /* ignore */ }
}

/** Drop the one-shot flag on logout so the next account keeps its own last page. */
export function clearFirstSignupHome() {
  try {
    localStorage.removeItem(LAND_HOME_KEY);
  } catch { /* ignore */ }
}

/**
 * First dashboard paint after signup. Returns true once, then clears the
 * flag so later visits restore whatever page the user actually opened.
 */
export function consumeFirstSignupHome(userId) {
  try {
    if (localStorage.getItem(LAND_HOME_KEY) !== '1') return false;
    writeHome(userId);
    localStorage.removeItem(LAND_HOME_KEY);
    try { sessionStorage.setItem('xph_welcome_home', '1'); } catch { /* ignore */ }
    return true;
  } catch {
    return false;
  }
}
